<template>
  <footer class="app-version" :class="{ 'dark-text': darkTextColor }">
    <a href="https://www.remondis-digital.com/datenschutzhinweise" target="_blank">
      {{ $t('meta.privacy') }}
    </a>
    –
    <a href="https://www.remondis-digital.com/impressum/" target="_blank">
      {{ $t('meta.legal') }}
    </a>
  </footer>
</template>

<script>
export default {
  props: {
    darkTextColor: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped>
.app-version {
  padding: 15px 0;
  text-align: left;
  color: var(--binity-blue);
  font-size: 12px;
  text-align: center;
  position: relative;
  width: 50%;
  margin: auto;
  z-index: 99999;

  &:not(.dark-text) {
    color: #fff;
  }

  a {
    color: currentColor;
    font-weight: 400;
  }
}

@media only screen and (max-width: 767px) {
  .app-version {
    width: 80%;
  }
}
</style>
